import axiosInstance from '../../../../config/axiosInstance';
const  QuotationStatusService = {
    async GetQuotationStatus(redirectCallback) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetQuotationStatus?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    
};

export default QuotationStatusService;